// Notifications API — mirrors /app/mobile/src/lib/notifications-api.ts
import { apiFetch } from './api';

export function listNotifications(unreadOnly = false, limit = 50) {
  return apiFetch(`/api/v1/notifications?unread_only=${unreadOnly}&limit=${limit}`);
}

export function getUnreadCount() {
  return apiFetch('/api/v1/notifications/unread-count');
}

export function markRead(notifId) {
  return apiFetch(`/api/v1/notifications/${notifId}/read`, { method: 'POST' });
}

export function markAllRead() {
  return apiFetch('/api/v1/notifications/read-all', { method: 'POST' });
}
